import { Injectable } from "@angular/core";
import { ThermalApi } from "../thermal-api";
import moment from "moment";

@Injectable()
export class AttendanceApi {

    constructor(
        private thermalApi: ThermalApi,
    ) {

    }

    setIdentifyCallBack(pass: string, callbackUrl: any) {
        const method: string = 'POST';
        const func: string = 'setIdentifyCallBack';
        const params = new FormData();
        params.append('pass', pass);
        params.append('callbackUrl', callbackUrl);
        return this.thermalApi.request(method, null, func, params);
    }

    findRecords(pass: string, personId: any, length: any, index: any, startTime: any, endTime: any, model: any, order: any = 0) {
        const method: string = 'GET';
        const func: string = 'newFindRecords';
        const params: any = {
            pass: pass,
            personId: personId,
            length: length,
            index: index,
            startTime: startTime,
            endTime: endTime,
            model: model,
            order: order
        };
        return this.thermalApi.request(method, null, func, params);
    }

    deleteRecordsByUnixTime(pass: string, unixTime: any) {
        const method: string = 'POST';
        const func: string = 'deleteRecordsByUnixTime';
        const params = new FormData();
        params.append('pass', pass);
        params.append('unixTime', unixTime);
        return this.thermalApi.request(method, null, func, params);
    }

    newDeleteRecords(data, pass: string = '12345678') {
        const method: string = 'POST';
        const func: string = 'newDeleteRecords';
        const startTime = moment(Number(data.time)).format('YYYY-MM-DD HH:mm:ss');
        const endTime = moment(Number(data.time)).add(1, 'second').format('YYYY-MM-DD HH:mm:ss');
        const params = new FormData();

        params.append('pass', pass);
        params.append('personId', data.personId);
        params.append('startTime', startTime);
        params.append('endTime', endTime);
        params.append('model', '-1');
        return this.thermalApi.request(method, null, func, params);
    }

}


// WEBPACK FOOTER //
// ./src/shared/thermal/services/attendance.api.ts